<!-- Display pending applications-->
<template>
  <div class="ExistingApplication">
    <ApplicationBanner data-testid="application-banner" content="<h1>Choose an <br /> application to continue</h1>" />
   <div class="pending-offers">
      <b-container class="content">
      <div v-if="cancelledApplication">
        <Notification
          class="notification-alert"
          :notification="cancelledApplication"
          data-testid="cancel-notification"
          @dismiss="cancelledApplication = null"
        />
      </div>
      <div v-if="hasInProgressApplication && inProgressApplication" class="white-card inProgressApplication" data-testid="inProgressApplication-section">
         <b-row>
          <b-col cols="3" md="2" class="text-center">
          <v-avatar
            size="60"
            color="primary lighten-4"
          >
            <v-icon
              color="primary"
              size="40"
              alt="In progress applications"
              aria-label="In progress applications"
            >
              restore
            </v-icon>
          </v-avatar>
          </b-col>
          <b-col cols="9" md="10">
            <h2>Application in progress</h2>
            <p>Please submit the application <strong>within 30 days,</strong> so the office can be notified of your offer acceptance.</p>
          </b-col>
         </b-row>
        <b-row>
          <b-col cols="3" md="2" class="text-center">
            <v-icon class="material-icons-outlined person-icon">person_outline</v-icon>
          </b-col>
          <b-col cols="9" md="10" class="application-details">
            <b-row>
              <b-col cols="12" md="7">
                <div class="item">
                  <h3>
                    <strong>
                      <span>{{ clientName }}</span>
                    </strong>
                  </h3>                
                </div>
              </b-col>
              <b-col cols="12" md="5">
                <div class="item proceedbtn"><b-button variant="primary" :aria-label="'Resume ' + resumeLabel" @click="resumeApplication" data-testid="resume-application">Resume</b-button></div>
                <div class="item"><b-button variant="outline-primary" :aria-label="'Cancel ' + resumeLabel" @click="cancelApplication" data-testid='cancel-application'>Cancel</b-button></div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <div v-if="existingApplication.length" class="white-card ooa-pending-offers" data-testid="pending-offers-section">
        <b-row>
          <b-col cols="3" md="2" class="text-center col">
            <v-avatar
            size="60"
            color="primary lighten-4"
          >
            <v-icon
                class="material-icons-outlined"
                color="primary"
                size="40"
                alt="Pending applications"
                aria-label="Pending applications"
            >
                new_releases
            </v-icon>
            </v-avatar>
          </b-col>
          <b-col cols="9" md="10">
            <h2>Existing Application</h2>
            <p>To proceed with an existing Application, select <strong>Proceed</strong> and submit a full application within <strong>14 days.</strong><br /> The building blocks will be notified of your acceptance. If you wish to decline, select <strong>Decline</strong> to send our office a notification.</p>
          </b-col>
        </b-row>
        <div v-for="application in existingApplication" :key="application.application.userId" class="mt-4">
        <b-row :class="existingApplication.length === 1 ? 'pb-6' : 'pb-0'">
          <b-col cols="3" md="2" class="text-center">
            <v-icon class="material-icons-outlined person-icon">person_outline</v-icon>
          </b-col>
          <b-col cols="9" md="10" class="application-details">
            <b-row>
            <b-col cols="12" md="7">
              <div class="item">
                <h3><strong>{{application.application.client.firstName}} <span v-if="application.application.client.otherName">{{application.application.client.otherName}}</span> {{application.application.client.lastName}}</strong></h3>                
              </div>
            </b-col>
           
            </b-row>
          </b-col>
        </b-row>
        <v-divider v-if="existingApplication.length > 1"></v-divider>
        </div>
      </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import ApplicationBanner from '@/components/application/ApplicationBanner.vue'
import endPoint from '@/store/endPoint'
import Notification from '@/components/app/Notification.vue'
import { API_ERROR_SUBTYPES } from '@/constants'

export default {
  name: 'ExistingApplication',
  components: {
    ApplicationBanner,
    Notification
  },
  props: {
    // show cancelled application alert for client
    cancelledApplicationClientName: {
      type: String
    }
  },
  data() {
    return {
      hasInProgressApplication: false,
      inProgressApplication: null,
      cancelledApplication: this.getCancelledAppNotificationData(
        this.cancelledApplicationClientName
      )
    }
  },
  computed: {
    ExistingApplication() {
      return this.$store.state.existingApplication || []
    },
   
    existingApplication() {
     
      return this.ExistingApplication
    },
    clientName() {
      const clientDetails = this.inProgressApplication.client
      if (
        clientDetails &&
        (clientDetails.firstName ||
          clientDetails.otherName ||
          clientDetails.lastName)
      ) {
        const clientFirstName = clientDetails.firstName
          ? clientDetails.firstName.trim()
          : ''
        const clientOtherName = clientDetails.otherName
          ? clientDetails.otherName.trim()
          : ''
        const clientlastName = clientDetails.lastName
          ? clientDetails.lastName.trim()
          : ''
        return (
          clientFirstName +
          ' ' +
          clientOtherName +
          ' ' +
          clientlastName
        ).trim()
      }
      return 'No name provided'
    },
    resumeLabel() {
      return `in progress application for ${this.clientName}`
    },
    declinedExistingApplication() {
      return this.$store.state.declinedExistingApplication
    }
  },
  created() {
    if (this.$store.state.auth.userId === '') {
      this.$router.history.push('/login/resume')
    } else {
      this.$store.commit('set', ['hasPendingApplication', false])
      endPoint
        .getFormData(this.$store.state.auth.idToken)
        .then(resp => {
          if (resp.data.message === 'Lookup successful') {
            this.hasInProgressApplication = true
            this.$store.commit('set', ['hasPendingApplication', true])
            this.inProgressApplication = resp.data.body.application
          }
        })
        .catch(error => {
          this.$store.dispatch('hideSpinner')
          this.$store.dispatch('setAPIError', {
            error,
            fallbackCode: API_ERROR_SUBTYPES.getApplication
          })
          this.$router.history.push('/error')
        })
    }
  },
  methods: {
    getCancelledAppNotificationData(clientName) {
      if (!clientName) return null

      return {
        type: 'info',
        title: 'Application in progress has been cancelled',
        body: `The in progress application for ${clientName} has been cancelled`
      }
    },
    applicationAriaLabel(application) {
      const name =
        application.application.client.firstName +
        ' ' +
        application.application.client.lastName
      application.ariaLabel = `pending application offer for ${name}`
    },
    resumeApplication() {
      this.$store.commit('set', ['declinedExistingApplication', []])
      this.$router.history.push('/application')
    },
    cancelApplication() {
      this.$store.dispatch('openModal', {
        componentName: 'ModalCancel',
        logout:
          this.ExistingApplication.length
            ? false
            : true,
        onCancelCallback: this.handleApplicationCancelled,
        application: this.inProgressApplication,
        size: 'small'
      })
    },
    handleApplicationCancelled() {
      this.cancelledApplication = this.getCancelledAppNotificationData(
        this.clientName
      )
      this.hasInProgressApplication = false
      this.inProgressApplication = null
      this.$store.commit('set', ['clientName', ''])   

      this.$store.dispatch('getExistingApplication')
    },
   
    selectedApplication(applicationID) {
      const { application } = this.declinedExistingApplication.find(
        ({ application }) => application.ooaApplicationID === applicationID
      )
      return application
    },
    dismiss(applicationID) {
      const applications = this.declinedExistingApplication.filter(
        application =>
          application.application.ooaApplicationID !== applicationID
      )
      this.$store.commit('set', ['declinedExistingApplication', applications])
    },
    notification(applicationID) {
      if (this.declinedExistingApplication.length > 0) {
        const application = this.selectedApplication(applicationID)
        const firstName = application.client.firstName
        const otherName = application.client.otherName
          ? application.client.otherName
          : ''
        const lastName = application.client.lastName
        const name = (firstName + ' ' + otherName + ' ' + lastName).trim()
        const notificationText = {
          title: 'Application declined',
          type: 'info',
          body: `The Application has been declined. The office has been notified and a confirmation email has been sent to 
            ${this.$store.state.auth.userId}`
        }
        return notificationText
      }
      return {}
    }
  }
}
</script>

<style lang="scss" scoped>
.pending-offers {
  position: relative;
  top: $header-height;
  margin-bottom: 3rem;
  padding-bottom: 3rem;
  .content {
    margin: 0 auto;
    &.container {
      padding: 40px 15px 15px;
    }
  }
}
.person-icon {
  font-size: 40px;
  padding: 5px 0 0;
}
.white-card.ooa-pending-offers {
  padding: 30px 0 0;
}
.inProgressApplication {
  margin-bottom: 40px;
  padding: 30px 0;
}
.application-details .item {
  display: inline-block;
  margin-right: 15px;
}
.notification-alert {
  max-width: 100%;
  margin-bottom: 40px;
}
@include desktop {
  .ExistingApplication {
    .ApplicationBanner {
      height: 204px;
      max-height: 204px;
    }
  }
}
@include tablet-wide {
  .ExistingApplication {
    .ApplicationBanner {
      height: 204px;
      max-height: 204px;
    }
  }
}
@include tablet {
  .ExistingApplication {
    .ApplicationBanner {
      height: 122px;
      max-height: 122px;
    }
  }
}
@include mobile {
  .application-details .item {
    display: block;
    width: 100%;
  }
  .application-details .item.proceedbtn {
    text-align: left;
  }
  .white-card,
  .white-card.ooa-pending-offers {
    padding: 30px 10px;
  }
}
</style>
